import React, { useState } from 'react'
import { useDraggableCollection } from '@fs/zion-frontend-friends'
import { useZionForm } from '@fs/zion-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { LayoutBand, H1, Separator, Row } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { baseUrl } from '@fs/zion-config'
import { i18n } from '@fs/zion-locale'
import { usePageView } from '@fs/zion-analytics'
import { solrSearch } from './services/LearnToRankService'
import { validationSchema } from './validation/searchValidation'
import { useDragAndDrop } from './hooks/useDragAndDrop'
import SearchForm from './components/SearchForm'
import RankingPanel from './components/RankingPanel'
import TrainingDataPanel from './components/TrainingDataPanel'
import AuthoritiesAppPageHead from '../../AuthoritiesAppPageHead'

export default function PlaceLearnToRankPage() {
  usePageView({ page_detail: 'PlaceLearnToRank' })
  const [t] = useTranslation()
  const { draggedItems, dragApi, reset } = useDraggableCollection([])
  const [searchQuery, setSearchQuery] = useState('')

  const methods = useZionForm({
    mode: 'all',
    resolver: yupResolver(validationSchema),
    defaultValues: {
      solrSearch: 'yuma az',
    },
  })

  const {
    formState: { isValid },
  } = methods

  const nativeDragApi = useDragAndDrop(dragApi)
  const [originalResults, setOriginalResults] = useState([])
  const onSubmit = async (values) => {
    const query = values.solrSearch
    setSearchQuery(query)

    const response = await solrSearch(query)
    const truncatedResults = response.results.slice(0, 10)
    const resultsWithOriginalIndex = truncatedResults.map((result, index) => ({
      ...result,
      originalIndex: index + 1,
    }))
    setOriginalResults(resultsWithOriginalIndex)
    reset(resultsWithOriginalIndex)
  }
  const handleResetOrder = () => {
    if (!originalResults.length) return
    reset(originalResults)
  }

  return (
    <>
      <AuthoritiesAppPageHead
        title={t('place-learn-to-rank-page.learn-to-rank.heading', 'Learn to Rank')}
        description={t(
          'place-learn-to-rank-page.page.description',
          'Train and optimize search ranking for place results'
        )}
        canonicalUrl={`${baseUrl}/${i18n.language}/standards/learn-to-rank/`}
      />
      <LayoutBand maxWidth="xxl">
        <Separator />
        <H1 size="H3">{t('place-learn-to-rank-page.learn-to-rank.heading', 'Learn to Rank')}</H1>
        <SearchForm methods={methods} onSubmit={onSubmit} isValid={isValid} />
        {draggedItems.length > 0 && (
          <>
            {/* Panels */}
            <Row gutters="nano" wrap>
              <RankingPanel draggedItems={draggedItems} nativeDragApi={nativeDragApi} onResetOrder={handleResetOrder} />
              <TrainingDataPanel noShrinkX draggedItems={draggedItems} searchQuery={searchQuery} />
            </Row>
          </>
        )}
      </LayoutBand>
    </>
  )
}
